import { render, staticRenderFns } from "./presentadorInformacionGeneral.vue?vue&type=template&id=3e1b1703"
import script from "./presentadorInformacionGeneral.vue?vue&type=script&lang=js"
export * from "./presentadorInformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports